import { Injectable, OnInit } from '@angular/core';

import { Storage } from '@ionic/storage-angular';

@Injectable()
export class StorageService {

  constructor(public storage: Storage) {
  }

  async init() {
    await this.storage.create();
  }

  async get(reference: string) {
    return await this.storage.get(reference);
  }

  async set(reference: string, value: any) {
    return await this.storage.set(reference, value);
  }

  async clear() {
    return await this.storage.clear()
  }

  async remove(reference: string) {
    return await this.storage.remove(reference)
  }
}